import CommonService from "@/services/api/CommonService";
import React, { useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "নাম বাধ্যতামূলক";
    if (!formData.phone.trim()) newErrors.phone = "ফোন নাম্বার বাধ্যতামূলক";
    if (!formData.email.trim()) {
      newErrors.email = "ইমেইল বাধ্যতামূলক";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "সঠিক ইমেইল দাও";
    }
    if (!formData.message.trim()) newErrors.message = "বার্তা লিখো";
    return newErrors;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      await CommonService.postContact(formData);
      toast.success("আপনার বার্তা সফলভাবে পাঠানো হয়েছে!");
      setFormData({ name: "", phone: "", email: "", message: "" });
    } catch (error) {
      toast.error("বার্তা পাঠাতে সমস্যা হয়েছে। আবার চেষ্টা করুন।");
    }
  };

  return (
    <>
      <div className="col-span-12">
        <div className="contact-form-part">
          <form onSubmit={handleSubmit} className="md:space-y-6 space-y-4">
            <label className="contact-lavel">আপনার নাম</label>
            <input
              type="text"
              name="name"
              placeholder="আপনার নাম"
              value={formData.name}
              onChange={handleChange}
              className="contact-input"
            />
            {errors.name && (
              <p className="!text-red-500 text-sm">{errors.name}</p>
            )}

            <label className="contact-lavel">ফোন নাম্বার</label>
            <input
              type="text"
              name="phone"
              placeholder="আপনার ফোন নাম্বার দিন"
              value={formData.phone}
              onChange={handleChange}
              className="contact-input"
            />
            {errors.phone && (
              <p className="!text-red-500 text-sm">{errors.phone}</p>
            )}

            <label className="contact-lavel">ইমেইল</label>
            <input
              type="email"
              name="email"
              placeholder="আপনার ইমেইল"
              value={formData.email}
              onChange={handleChange}
              className="contact-input"
            />
            {errors.email && (
              <p className="!text-red-500 text-sm">{errors.email}</p>
            )}

            <label className="contact-lavel">বার্তা</label>
            <textarea
              name="message"
              placeholder="আপনার বার্তা লেখুন"
              rows="4"
              value={formData.message}
              onChange={handleChange}
              className="contact-input"
            ></textarea>
            {errors.message && (
              <p className="!text-red-500 text-sm">{errors.message}</p>
            )}

            <button
              type="submit"
              className="contact-button flex items-center gap-2"
            >বার্তা পাঠান <FaArrowRight />
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
